import React, { useState } from 'react';
import classnames from 'classnames';
import { usePages } from '@ignitesales/neuro-application/src/neuro-guide';
import PropTypes from 'prop-types';
import ReactSVG from 'react-svg';
import HeaderMenu from './modals/HeaderMenu';

const Header = ({ className }) => {

  const [ showMenu, setShowMenu ] = useState(false);
  const { currentPageUrl } = usePages();

  const classes = classnames(
    'header',
    className
  );

  return <>
    <header className={classes}>
      <div className="logo">
        <ReactSVG src="/classpath/assets/images/commerce_logo_full.svg" />
      </div>

      <div className="decoration top">
        <div className="circle grey-dark-sm">
        </div>
        <div className="circle green">
        </div>
      </div>

      { (currentPageUrl && currentPageUrl !== "/guide" && !currentPageUrl.includes("details")) && <button className="header-menu-btn" onClick={() => setShowMenu(true)}>
        <ReactSVG src="/classpath/assets/images/icons/icon-hamburger.svg" />
      </button>}

      { showMenu && <HeaderMenu showMenu={showMenu} setShowMenu={setShowMenu} currentPage={currentPageUrl} /> }

    </header>
  </>;
};

Header.propTypes = {
  className: PropTypes.string
};

export default Header;
